// Allinks 平台管理后台 mock 数据（演示样例）
// 品牌：Allinks · 平台管理后台（UI-R06 合规）

// ===== 代理商（dt 源数据）=====
export interface OrigAgent {
  id: string;
  name: string;
  contact: string;
  email: string;
  phone: string;
  status: 'active' | 'suspended' | 'review';
  marginBalance: number; // 保证金
  fiatBalance: number; // 法币余额
  merchantCount: number;
  cardCount: number;
  monthlyVolume: number;
  joinDate: string;
  vaAccount: string;
  feeRate: number;
  profitShare: number;
  commissionBalance: number; // 未提现佣金
}

export const agents: OrigAgent[] = [
  { id: 'AGT001', name: '星辰国际金融', contact: '李明', email: 'li@stargroup.com', phone: '+86 13800138001', status: 'active', marginBalance: 50000, fiatBalance: 820000, merchantCount: 12, cardCount: 480, monthlyVolume: 1200000, joinDate: '2023-06-10', vaAccount: 'VA1122334455', feeRate: 1.2, profitShare: 20, commissionBalance: 14353 },
  { id: 'AGT002', name: '汇通金融服务', contact: '王芳', email: 'wang@huitong.com', phone: '+86 13800138002', status: 'active', marginBalance: 80000, fiatBalance: 457000, merchantCount: 18, cardCount: 720, monthlyVolume: 2800000, joinDate: '2023-08-15', vaAccount: 'VA2233445566', feeRate: 1, profitShare: 22, commissionBalance: 12800 },
  { id: 'AGT006', name: '鼎盛金融集团', contact: '赵磊', email: 'zhao@dingsheng.com', phone: '+86 13622334455', status: 'active', marginBalance: 120000, fiatBalance: 480000, merchantCount: 38, cardCount: 1560, monthlyVolume: 5200000, joinDate: '2023-03-05', vaAccount: 'VA5544332211', feeRate: 1, profitShare: 25, commissionBalance: 32000 },
  { id: 'AGT005', name: '银河支付科技', contact: '刘洋', email: 'liu@galaxy.com', phone: '+86 13788990011', status: 'suspended', marginBalance: 10000, fiatBalance: 45000, merchantCount: 4, cardCount: 85, monthlyVolume: 120000, joinDate: '2023-11-20', vaAccount: 'VA6655442211', feeRate: 1.5, profitShare: 15, commissionBalance: 850 },
  // 模拟代理商扩展
  ...Array.from({ length: 12 }).map((_, i) => ({
    id: `AGT-EXT-${i}`, name: `模拟代理商 ${i + 1}`, contact: `代理${i + 1}`,
    email: `agent${i + 1}@demo.com`, phone: '+86 1380000' + String(1000 + i),
    status: 'active' as const, marginBalance: 20000, fiatBalance: 100000,
    merchantCount: 5 + i, cardCount: 100 + i * 10, monthlyVolume: 300000,
    joinDate: '2024-01-01', vaAccount: `VA-EXT-${i}`, feeRate: 1.2, profitShare: 20,
    commissionBalance: 5000 + Math.floor(Math.random() * 15000),
  })),
];

// ===== 商户（Lt 源数据）=====
export interface OrigMerchant {
  id: string;
  agentId: string;
  agentName: string;
  name: string;
  contact: string;
  email: string;
  phone: string;
  status: 'active' | 'suspended' | 'review';
  fiatBalance: number; // 钱包余额
  cardBalance: number; // 卡片余额
  creditRatio: number; // 授信倍数
  cardholderCount: number;
  cardCount: number;
  cardQuota: number;
  monthlyCardQuota: number;
  monthlyVolume: number;
  totalVolume: number;
  joinDate: string;
  feeRate: number;
  profitShare: number;
  rechargeRate: number;
  kycLevel: number;
  level: string;
}

export const merchants: OrigMerchant[] = [
  { id: 'MCH001', agentId: 'AGT002', agentName: '汇通金融服务', name: '环球购物服务', contact: '周小明', email: 'zhou@globalshop.hk', phone: '+852 8123 4567', status: 'active', fiatBalance: 10000, cardBalance: 10000, creditRatio: 200, cardholderCount: 234, cardCount: 312, cardQuota: 500, monthlyCardQuota: 100, monthlyVolume: 380000, totalVolume: 4500000, joinDate: '2024-01-20', feeRate: 2.5, profitShare: 20, rechargeRate: 1, kycLevel: 2, level: 'V2' },
  { id: 'MCH002', agentId: 'AGT001', agentName: '星辰国际金融', name: '亿通数字服务', contact: '吴海涛', email: 'wu@yitong.hk', phone: '+852 8234 5678', status: 'active', fiatBalance: 4000, cardBalance: 16000, creditRatio: 200, cardholderCount: 156, cardCount: 198, cardQuota: 300, monthlyCardQuota: 80, monthlyVolume: 210000, totalVolume: 1800000, joinDate: '2024-02-14', feeRate: 2.8, profitShare: 18, rechargeRate: 1.5, kycLevel: 2, level: 'V1' },
  { id: 'MCH003', agentId: 'AGT006', agentName: '鼎盛金融集团', name: '泰和智能科技', contact: '孙志强', email: 'sun@taihe.hk', phone: '+852 8345 6789', status: 'review', fiatBalance: 0, cardBalance: 0, creditRatio: 100, cardholderCount: 0, cardCount: 0, cardQuota: 0, monthlyCardQuota: 0, monthlyVolume: 0, totalVolume: 120000, joinDate: '2025-04-08', feeRate: 2.2, profitShare: 22, rechargeRate: 1.2, kycLevel: 1, level: 'V1' },
  // 模拟商户扩展
  ...Array.from({ length: 15 }).map((_, i) => ({
    id: `MCH-EXT-${i}`, agentId: 'AGT001', agentName: '星辰国际金融', name: `模拟商户 ${i + 1}`,
    contact: `商户${i + 1}`, email: `mch${i + 1}@demo.com`, phone: '+852 8000 ' + String(1000 + i),
    status: 'active' as const, fiatBalance: 20000 + Math.floor(Math.random() * 30000),
    cardBalance: 30000 + Math.floor(Math.random() * 50000), creditRatio: 200,
    cardholderCount: 100, cardCount: 100 + Math.floor(Math.random() * 400),
    cardQuota: 500, monthlyCardQuota: 100, monthlyVolume: 200000, totalVolume: 1000000,
    joinDate: '2024-03-01', feeRate: 2.5, profitShare: 20, rechargeRate: 1, kycLevel: 2, level: 'V2',
  })),
];

// ===== 通道（cp 源数据）=====
export interface OrigChannel {
  id: string;
  name: string;
  provider: string;
  margin: number; // 保证金
  balance: number; // 资金余额
}

export const channels: OrigChannel[] = [
  { id: 'CHN001', name: '通联支付主通道', provider: 'Allinpay', margin: 500000, balance: 2500000 },
  { id: 'CHN002', name: 'Visa备付金网络', provider: 'Visa', margin: 1000000, balance: 1800000 },
  { id: 'CHN003', name: 'Mastercard结算', provider: 'Mastercard', margin: 800000, balance: 1200000 },
  { id: 'CHN004', name: 'Stripe国际通道', provider: 'Stripe', margin: 300000, balance: 900000 },
  ...Array.from({ length: 12 }).map((_, i) => ({
    id: `CHN-EXT-${i}`, name: `备用通道 ${i + 1}`, provider: 'Other',
    margin: 50000 + i * 10000, balance: 100000 + i * 20000,
  })),
];

// ===== 入金审核（xp 源数据）=====
export interface OrigDeposit {
  id: string;
  merchantName: string;
  merchantId: string;
  agentName: string;
  amount: number;
  method: string; // 入金方式 / 凭证
  type: 'bank_slip' | 'TRC20' | 'ERC20' | 'wire';
  status: 'pending' | 'approved' | 'rejected' | 'exception' | 'ignored';
  rawStatus?: string;
  submitter: string;
  submittedAt: string;
  reviewer?: string;
  reviewedAt?: string;
  rejectReason?: string;
  slipFileId?: string;
}

export const deposits: OrigDeposit[] = [
  { id: 'DEP001', merchantName: '环球购物服务', merchantId: 'MCH001', agentName: '汇通金融服务', amount: 50000, method: 'bank_slip_MCH001_0415.pdf 银行水单', type: 'bank_slip', status: 'pending', submitter: '运营 张明', submittedAt: '2025-04-15 10:30:00' },
  { id: 'DEP002', merchantName: '亿通数字服务', merchantId: 'MCH002', agentName: '星辰国际金融', amount: 30000, method: 'TRC20 TEabcd1234efgh5678ijkl9012mnop3456qrst', type: 'TRC20', status: 'pending', submitter: '运营 李红', submittedAt: '2025-04-15 11:45:00' },
  { id: 'DEP003', merchantName: '星辰跨境贸易', merchantId: 'MCH004', agentName: '汇通金融服务', amount: 15000, method: 'wire_receipt_MCH004.jpg 银行水单', type: 'wire', status: 'approved', submitter: '运营 张明', submittedAt: '2025-04-13 09:20:00', reviewer: '管理员 王总', reviewedAt: '2025-04-13 14:05:00' },
  { id: 'DEP004', merchantName: '云端网络科技', merchantId: 'MCH005', agentName: '鼎盛金融集团', amount: 100000, method: 'ERC20 0xabcdef1234567890abcdef1234567890abcdef12', type: 'ERC20', status: 'rejected', submitter: '运营 李红', submittedAt: '2025-04-12 16:00:00', reviewer: '管理员 王总', reviewedAt: '2025-04-12 18:30:00', rejectReason: 'TxHash验证失败，请重新提交' },
];

// ===== 数据概览 KPI（运营驾驶舱）=====
export const overviewStats = {
  escrow: 4250000, // 平台备付金 $4.25M
  agentRechargeToday: 350000, // 今日代理充值 $350K
  merchantRechargeToday: 195000, // 今日商户充值 $195K
  withdrawToday: 45000, // 今日提现 $45K
  withdrawPending: 12, // 12笔待审核
  activeCards: 12340, // 活跃卡片
  totalCards: 15890, // 共 15,890 张
  cardPool: 4, // 可用卡池（演示值）
  cardPoolTotal: 12, // 总 12 张待分配
  riskAlerts: 3, // 风险预警
  // 月度营收
  monthlyRevenue: 235000,
  monthlyRevenueGrowth: 18.5,
  openCardFee: 45200,
  openCardFeeGrowth: 22.1,
  rechargeSpread: 168300,
  rechargeSpreadGrowth: 15.8,
  visaRebate: 21000,
  visaRebateGrowth: 8.2,
};

// 月度营收趋势（近 12 月，单位 USD）
export const revenueTrend = [
  { month: '1月', revenue: 180000, spend: 1200000 },
  { month: '2月', revenue: 195000, spend: 1350000 },
  { month: '3月', revenue: 210000, spend: 1500000 },
  { month: '4月', revenue: 198000, spend: 1480000 },
  { month: '5月', revenue: 220000, spend: 1650000 },
  { month: '6月', revenue: 235000, spend: 1780000 },
];

// 卡片状态分布
export const cardStatusDist = [
  { label: '已分配', value: 12340, color: 'bg-brand-500' },
  { label: '可用卡池', value: 2100, color: 'bg-emerald-500' },
  { label: '已冻结', value: 890, color: 'bg-amber-500' },
  { label: '已注销', value: 560, color: 'bg-slate-400' },
];

// 月开卡量（近 12 月）
export const monthlyCardIssuance = [
  { month: '1月', count: 820 }, { month: '2月', count: 950 }, { month: '3月', count: 1000 },
  { month: '4月', count: 1000 }, { month: '5月', count: 2000 }, { month: '6月', count: 2000 },
  { month: '7月', count: 2000 }, { month: '8月', count: 2000 }, { month: '9月', count: 3000 },
  { month: '10月', count: 3000 }, { month: '11月', count: 3000 }, { month: '12月', count: 3000 },
];

// 代理商余额概览 Top
export const agentBalanceTop = [
  { name: '鼎盛金融集团', balance: 892000 },
  { name: '汇通金融服务', balance: 457000 },
  { name: '星辰国际金融', balance: 235000 },
  { name: '东方通汇', balance: 178000 },
];

// 最新交易记录
export interface OrigTx {
  type: string;
  desc: string;
  amount: string;
  time: string;
  status: string;
}
export const latestTransactions: OrigTx[] = [
  { type: '商户余额充值', desc: '鼎盛金融集团 VA → 富盛金融科技 商户账户', amount: '+$50,000', time: '09:23:14', status: '完成' },
  { type: '代理商法币划转平台', desc: '汇通金融服务 VA → 平台备付金账户', amount: '+$150,000', time: '10:00:00', status: '完成' },
  { type: '在线购物消费', desc: '4111****1234 → Amazon.com', amount: '$89.99', time: '14:20:00', status: '完成' },
  { type: '订阅服务扣费', desc: '4111****1234 → Netflix', amount: '$15.99', time: '09:00:00', status: '完成' },
  { type: 'AI服务订阅', desc: '5241****8899 → ChatGPT Plus', amount: '$20', time: '08:30:00', status: '完成' },
  { type: '硬件购买', desc: '4111****1234 → Apple Store', amount: '$999', time: '18:00:00', status: '完成' },
];

// 待处理事项
export const todoSummary = {
  total: 15,
  withdrawPending: 12,
  riskAlerts: 3,
};

// ===== 通道管理页（账户卡片）=====
// 建模对齐上游通联 GCP（docs/upstream/跨境香港发卡API文档.md）：
//   authcus(15位客户号) + merid(15位商户号) 为请求公共参数（1.4）
//   代理商通道账户 = 上游子商户 cusid（5001 创建 / 5002 审核 / 5000 查询）
//   VA 收款账户为入金侧三层结构：id / accountno(内部虚拟账号) / vaaccountno(收款账号)（6004 / 1001）
//   密钥为全局一套（RSA+AES+keyId+通知地址，见 allinpay-api.yml），非每账户独立
export interface OrigChannelAccount {
  id: string;
  name: string;
  desc: string;
  authcus: string; // 客户号（15 位数字，上游公共参数）
  merid: string; // 商户号（15 位数字，上游公共参数）
  cusid?: string; // 子商户号（上游 5001 响应；仅代理商通道账户有值）
  vaAccountNo: string; // VA 收款账户号（上游 6004 vaaccountno）
  accountNo?: string; // 通联内部虚拟账号（上游 6004 accountno，800 前缀）
  currency: string; // 币种（上游 6004 currency）
  keyStatus: 'configured' | 'partial' | 'missing'; // 全局密钥配置状态
  env: '生产' | '测试'; // 对接环境（上游 global-test / global）
  status: 'REGISTERED' | 'AUDITING' | 'FAILED' | 'DISABLED'; // 子商户/账户审核状态（5000/5002）
  lastSyncAt: string; // 最近一次上游同步/对账时间
  note?: string;
}

export const channelAccounts: OrigChannelAccount[] = [
  {
    id: 'CHN001', name: '平台官方账户', desc: '主 VA 绑定账户 · 平台自营业务专用（上游主商户 + 主 VA 收款户）',
    authcus: '665000000000001', merid: '668000000000101',
    vaAccountNo: '800000000000000000000000000001', accountNo: '8000000000000000000001', currency: 'USD',
    keyStatus: 'configured', env: '生产', status: 'REGISTERED', lastSyncAt: '2026-08-08 09:20:00',
  },
  {
    id: 'AGT001', name: '香港数字金融', desc: '港区代理子商户通道 · 已注册',
    authcus: '665000000000001', merid: '668000000000101', cusid: '888000000000101',
    vaAccountNo: '800000000000000000000000000101', accountNo: '8000000000000000000101', currency: 'HKD',
    keyStatus: 'configured', env: '生产', status: 'REGISTERED', lastSyncAt: '2026-08-08 08:45:00',
  },
  {
    id: 'AGT002', name: '新加坡支付科技', desc: '星洲代理子商户通道 · 上游审核中',
    authcus: '665000000000001', merid: '668000000000101', cusid: '888000000000102',
    vaAccountNo: '800000000000000000000000000102', accountNo: '8000000000000000000102', currency: 'USD',
    keyStatus: 'partial', env: '测试', status: 'AUDITING', lastSyncAt: '2026-08-07 16:30:00',
    note: '上游子商户审核中（5002 未通知），审核通过后 cusid 状态转「已注册」',
  },
  {
    id: 'AGT003', name: '深圳跨境电商', desc: '大湾区代理子商户通道',
    authcus: '665000000000001', merid: '668000000000101', cusid: '888000000000103',
    vaAccountNo: '800000000000000000000000000103', accountNo: '8000000000000000000103', currency: 'USD',
    keyStatus: 'missing', env: '生产', status: 'FAILED', lastSyncAt: '2026-08-07 11:00:00',
    note: '上游子商户审核失败（5002），请核对营业执照后重新提交 5001',
  },
];

// ===== 资金概览汇总 =====
export const financeSummary = {
  platformPool: 12780000, // 平台资金池
  merchantPool: 552897, // 商户资金池
  cardBalanceTotal: 705877, // 卡片余额总计
  unpaidCommission: 175046, // 未提现佣金
};

// ===== 佣金提现审核（WC 源数据）=====
export interface OrigWithdrawal {
  id: string;
  agentName: string;
  agentId: string;
  contact: string;
  amount: number;
  availableBalance: number;
  channel: string; // 提现渠道 / 账户
  channelType: 'bank' | 'USDT-TRC20' | 'USDT-ERC20';
  status: 'pending' | 'paying' | 'done' | 'rejected';
  appliedAt: string;
  reviewer?: string;
  reviewedAt?: string;
  rejectReason?: string;
}

export const withdrawals: OrigWithdrawal[] = [
  { id: 'WC001', agentName: '鼎盛金融集团', agentId: 'AGT006', contact: '赵磊', amount: 20000, availableBalance: 32000, channel: '中国银行香港 · 012-345-6789-001', channelType: 'bank', status: 'pending', appliedAt: '2025-04-15 10:12:00' },
  { id: 'WC002', agentName: '汇通金融服务', agentId: 'AGT002', contact: '李娜', amount: 8000, availableBalance: 12800, channel: 'USDT · TRC20 · TKxxxx...xxxx88', channelType: 'USDT-TRC20', status: 'pending', appliedAt: '2025-04-15 09:45:00' },
  { id: 'WC003', agentName: '星辰国际金融', agentId: 'AGT001', contact: '张伟', amount: 4000, availableBalance: 4500, channel: 'USDT · ERC20 · 0xabcdef...cdef12', channelType: 'USDT-ERC20', status: 'paying', appliedAt: '2025-04-14 16:30:00', reviewer: '管理员 王总', reviewedAt: '2025-04-14 18:00:00' },
  { id: 'WC004', agentName: '东方通汇', agentId: 'AGT004', contact: '陈辉', amount: 1500, availableBalance: 2100, channel: '渣打银行香港 · 447-001-223344', channelType: 'bank', status: 'done', appliedAt: '2025-04-13 11:00:00', reviewer: '管理员 王总', reviewedAt: '2025-04-13 14:20:00' },
  { id: 'WC005', agentName: '银河支付科技', agentId: 'AGT005', contact: '刘洋', amount: 1000, availableBalance: 850, channel: '汇丰银行香港 · 123-456-789', channelType: 'bank', status: 'rejected', appliedAt: '2025-04-12 09:00:00', reviewer: '管理员 王总', reviewedAt: '2025-04-12 11:30:00', rejectReason: '提现金额超过账户可用余额，请核实后重新申请。' },
];

// ===== 风险预警（卡片式告警）=====
// category: 告警分类（用于 RiskAlerts 页 Tab 筛选）
export interface OrigRiskAlert {
  level: '严重' | '警告' | '提示';
  type: string;
  category: '反欺诈' | 'AML' | '交易异常' | '账户异常';
  target: string;
  targetId: string;
  desc: string;
  time: string;
  handler?: string;
  status: 'pending' | 'processing' | 'resolved' | 'ignored';
}

export const riskAlerts: OrigRiskAlert[] = [
  { level: '严重', type: '频率异常', category: '反欺诈', target: '亿通数字服务', targetId: 'MCH002', desc: '商户旗下30分钟内发生23笔订阅消费，触发速率风控，疑似卡片被批量滥用', time: '2025-04-14 22:15:00', handler: '风控 张明', status: 'processing' },
  { level: '警告', type: '大额交易', category: '交易异常', target: '4111****1234', targetId: 'card', desc: '单笔交易 $8,500 超过阈值 $5,000，需人工复核', time: '2025-04-14 18:30:00', status: 'pending' },
  { level: '严重', type: 'AML 命中', category: 'AML', target: '5241****8899', targetId: 'card', desc: '卡片交易命中制裁名单模式，已自动冻结待人工复核', time: '2025-04-14 15:00:00', handler: '风控 张明', status: 'processing' },
  { level: '提示', type: '异地登录', category: '账户异常', target: '管理员 王总', targetId: 'admin', desc: '检测到管理员账号从新 IP 登录', time: '2025-04-14 09:00:00', status: 'resolved' },
  { level: '严重', type: '盗刷嫌疑', category: '反欺诈', target: '5241****0011', targetId: 'card', desc: '该卡 1 小时内在 3 个不同国家产生 5 笔交易，疑似盗刷', time: '2025-04-14 20:42:00', status: 'pending' },
  { level: '警告', type: '高频充值', category: '交易异常', target: '泰和智能科技', targetId: 'MCH003', desc: '商户 1 小时内发起 8 次充值申请，触发频率阈值', time: '2025-04-14 16:20:00', handler: '风控 李四', status: 'resolved' },
  { level: '严重', type: '制裁名单', category: 'AML', target: '中盈跨境贸易', targetId: 'MCH003', desc: '商户实控人姓名与 OFAC 制裁名单高度匹配，需立即核查', time: '2025-04-13 11:00:00', status: 'pending' },
  { level: '警告', type: '密码暴力破解', category: '账户异常', target: '代理商 环球通支付', targetId: 'AGT003', desc: '账号 5 分钟内登录失败 12 次，已临时锁定', time: '2025-04-13 08:30:00', handler: '风控 张明', status: 'ignored' },
];

// ===== 代理商管理（补充展示字段）=====
export interface OrigAgentRow {
  code: string;
  shortCode: string; // ST/HT/GF
  name: string;
  email: string;
  contact: string;
  phone?: string; // 联系电话
  joinDate?: string; // 入驻日期
  vaAccount?: string; // VA 账户号
  margin: number;
  commission: number;
  merchantCount: number;
  cardCount: number;
  walletRate: string;
  productCount: number;
  status: '正常' | '待审核' | '已停用';
}

export const agentRows: OrigAgentRow[] = [
  { code: 'AGT001', shortCode: 'ST', name: '星辰国际金融', email: 'zhang@star.com', contact: '张伟', phone: '+86 13800138001', joinDate: '2023-05-12', vaAccount: 'VA8800112233', margin: 50000, commission: 4500, merchantCount: 15, cardCount: 450, walletRate: '0.8%', productCount: 2, status: '正常' },
  { code: 'AGT002', shortCode: 'HT', name: '汇通金融服务', email: 'li@huitong.hk', contact: '李娜', phone: '+852 9876 5432', joinDate: '2023-07-20', vaAccount: 'VA8800223344', margin: 80000, commission: 12800, merchantCount: 24, cardCount: 820, walletRate: '0.5%', productCount: 2, status: '正常' },
  { code: 'AGT003', shortCode: 'GF', name: '环球通支付', email: 'wang@global.sg', contact: '王强', phone: '+65 9123 4567', joinDate: '2025-04-18', vaAccount: '—', margin: 0, commission: 0, merchantCount: 0, cardCount: 0, walletRate: '1%', productCount: 1, status: '待审核' },
  { code: 'AGT004', shortCode: 'GF', name: '东方通汇', email: 'chen@east.com', contact: '陈辉', phone: '+86 13900139000', joinDate: '2023-09-05', vaAccount: 'VA8800445566', margin: 30000, commission: 2100, merchantCount: 9, cardCount: 210, walletRate: '1.2%', productCount: 1, status: '正常' },
  { code: 'AGT005', shortCode: 'GF', name: '银河支付科技', email: 'liu@galaxy.com', contact: '刘洋', phone: '+86 13700138000', joinDate: '2023-11-15', vaAccount: 'VA8800556677', margin: 10000, commission: 850, merchantCount: 4, cardCount: 85, walletRate: '0.8%', productCount: 1, status: '已停用' },
  { code: 'AGT006', shortCode: 'GF', name: '鼎盛金融集团', email: 'zhao@dingsheng.com', contact: '赵磊', phone: '+852 9012 3456', joinDate: '2023-03-08', vaAccount: 'VA8800667788', margin: 120000, commission: 32000, merchantCount: 38, cardCount: 1560, walletRate: '0.4%', productCount: 1, status: '正常' },
];

// ===== 商户管理（卡片式）=====
export interface OrigMerchantCard {
  initial: string;
  name: string;
  code: string;
  agentName: string;
  agentId: string;
  cardTotal: number;
  walletBalance: number;
  productCount: number;
  cardUsed: number;
  cardQuota: number;
  status: '正常运营' | '待中台审核' | '资料待补' | '停用';
  kycLevel: number;
}

export const merchantCards: OrigMerchantCard[] = [
  { initial: '环', name: '环球购物服务', code: 'HT-MCH-001', agentName: '汇通金融服务', agentId: 'AGT002', cardTotal: 10000, walletBalance: 10000, productCount: 2, cardUsed: 312, cardQuota: 500, status: '正常运营', kycLevel: 2 },
  { initial: '亿', name: '亿通数字服务', code: 'ST-MCH-002', agentName: '星辰国际金融', agentId: 'AGT001', cardTotal: 16000, walletBalance: 4000, productCount: 1, cardUsed: 198, cardQuota: 300, status: '正常运营', kycLevel: 2 },
  { initial: '泰', name: '泰和智能科技', code: 'GF-MCH-003', agentName: '鼎盛金融集团', agentId: 'AGT006', cardTotal: 0, walletBalance: 0, productCount: 0, cardUsed: 0, cardQuota: 0, status: '待中台审核', kycLevel: 1 },
  { initial: '先', name: '先锋国际支付', code: 'HT-MCH-007', agentName: '汇通金融服务', agentId: 'AGT002', cardTotal: 0, walletBalance: 0, productCount: 0, cardUsed: 0, cardQuota: 0, status: '资料待补', kycLevel: 1 },
];

// ===== 卡片管理 =====
export interface OrigCardRow {
  pan: string;
  type: '虚拟卡' | '实体卡';
  bin: string;
  agentName: string;
  agentId: string;
  merchantName: string;
  merchantId: string;
  product: string;
  channel: string;
  balance: number;
  openDate: string;
  validThru: string;
  status: '已激活' | '待激活' | '已冻结' | '已注销';
}

export const cardRows: OrigCardRow[] = [
  { pan: '4111 **** **** 1234', type: '虚拟卡', bin: 'BIN 411111 · Visa', agentName: '汇通金融服务', agentId: 'AGT002', merchantName: '环球购物服务', merchantId: 'MCH001', product: '优享Visa商务实体卡', channel: 'CHN001', balance: 125.50, openDate: '2024-02-01', validThru: '2027-06', status: '已激活' },
  { pan: '4532 **** **** 5678', type: '实体卡', bin: 'BIN 453200 · Visa', agentName: '星辰国际金融', agentId: 'AGT001', merchantName: '亿通数字服务', merchantId: 'MCH002', product: '万事达全球付标准卡', channel: 'CHN002', balance: 0, openDate: '2023-10-08', validThru: '2028-03', status: '待激活' },
  { pan: '5241 **** **** 8899', type: '虚拟卡', bin: 'BIN 524100 · Mastercard', agentName: '汇通金融服务', agentId: 'AGT002', merchantName: '环球购物服务', merchantId: 'MCH001', product: '万事达全球付标准卡', channel: 'CHN001', balance: 45.00, openDate: '2024-03-15', validThru: '2026-09', status: '已冻结' },
  { pan: '4111 **** **** 9911', type: '虚拟卡', bin: 'BIN 411111 · Visa', agentName: '领航全球结算', agentId: 'AGT003', merchantName: '中盈跨境贸易', merchantId: 'MCH003', product: '优享Visa商务实体卡', channel: 'CHN001', balance: 880.00, openDate: '2024-04-01', validThru: '2027-12', status: '已激活' },
  { pan: '4111 **** **** 2233', type: '虚拟卡', bin: 'BIN 411111 · Visa', agentName: '汇通金融服务', agentId: 'AGT002', merchantName: '环球购物服务', merchantId: 'MCH001', product: '优享Visa商务实体卡', channel: 'CHN001', balance: 12.00, openDate: '2024-04-05', validThru: '2028-01', status: '已激活' },
  { pan: '4532 **** **** 7788', type: '实体卡', bin: 'BIN 453200 · Visa', agentName: '星辰国际金融', agentId: 'AGT001', merchantName: '亿通数字服务', merchantId: 'MCH002', product: '万事达全球付标准卡', channel: 'CHN002', balance: 1000.50, openDate: '2024-01-15', validThru: '2029-06', status: '已激活' },
  { pan: '5241 **** **** 0011', type: '虚拟卡', bin: 'BIN 524100 · Mastercard', agentName: '鼎盛金融集团', agentId: 'AGT006', merchantName: '泰和智能科技', merchantId: 'MCH003', product: '万事达全球付标准卡', channel: 'CHN001', balance: 5.20, openDate: '2024-05-20', validThru: '2027-05', status: '已注销' },
];

// ===== 产品管理（费率卡片）=====
export interface OrigProduct {
  id: string; // PROD-001
  name: string; // 经典虚拟卡
  type: '虚拟卡' | '实体卡'; // 产品类型
  network: string; // Visa / Mastercard
  bin: string; // 400012
  channel: string; // 发行通道
  status: '运行中' | '已下架';
  auditAt: string; // 审计时间
  fees: {
    issuance: number; // 开卡费用 USD
    recharge: number; // 充值费率 %
    monthly: number; // 月管理费 USD
    auth: number; // 授权手续费 %
    tx: number; // 交易手续费 %
    crossBorder: number; // 跨境手续费 %
    other: number; // 其他费用 %
  };
  threshold: {
    minSpend: number; // 单笔最低消费限额 USD
    smallFee: number; // 小额交易附加费 USD/笔
  };
}

export const products: OrigProduct[] = [
  {
    id: 'PROD-001', name: '经典虚拟卡', type: '虚拟卡', network: 'Visa', bin: '400012',
    channel: '通联支付主通道', status: '运行中', auditAt: '2025-04-10',
    fees: { issuance: 2, recharge: 1.2, monthly: 0, auth: -0.1, tx: -0.4, crossBorder: 0, other: 0 },
    threshold: { minSpend: 5, smallFee: 0.5 },
  },
  {
    id: 'PROD-002', name: '优享Mastercard虚拟卡', type: '虚拟卡', network: 'Mastercard', bin: '530012',
    channel: '通联支付主通道', status: '运行中', auditAt: '2025-03-22',
    fees: { issuance: 3, recharge: 1.5, monthly: 0, auth: -0.15, tx: -0.5, crossBorder: 0, other: 0 },
    threshold: { minSpend: 5, smallFee: 0.5 },
  },
  {
    id: 'PROD-003', name: 'Visa Physical Tap', type: '实体卡', network: 'Visa', bin: '491600',
    channel: '通联支付主通道', status: '运行中', auditAt: '2025-02-15',
    fees: { issuance: 8, recharge: 1.2, monthly: 1, auth: -0.1, tx: -0.4, crossBorder: 0.5, other: 0 },
    threshold: { minSpend: 5, smallFee: 0.5 },
  },
];

// ===== 实体卡审批 =====
export interface OrigPhysicalApproval {
  orderNo: string; // ORD-20250420-001
  submittedAt: string;
  merchantName: string;
  agentName: string;
  kycCount: number; // 份 KYC
  cardCount: number; // 张
  network: string; // Visa
  product: string; // Visa Physical Tap
  status: '待审批' | '制卡中' | '待发货' | '已发货' | '已驳回';
  progress: number; // 制卡进度 %
  trackingNo?: string; // 物流单号
  rejectReason?: string; // 驳回原因
}

export const physicalApprovals: OrigPhysicalApproval[] = [
  { orderNo: 'ORD-20250420-001', submittedAt: '2025-04-20 09:30', merchantName: '环球购物服务', agentName: '汇通金融服务', kycCount: 4, cardCount: 120, network: 'Visa', product: 'Visa Physical Tap', status: '待审批', progress: 0 },
  { orderNo: 'ORD-20250419-002', submittedAt: '2025-04-19 14:10', merchantName: '亿通数字服务', agentName: '星辰国际金融', kycCount: 2, cardCount: 50, network: 'Visa', product: 'Visa Physical Tap', status: '制卡中', progress: 65 },
  { orderNo: 'ORD-20250419-005', submittedAt: '2025-04-19 09:10', merchantName: '海淘科技', agentName: '汇通金融服务', kycCount: 1, cardCount: 10, network: 'Visa', product: 'Visa Physical Tap', status: '待发货', progress: 100 },
  { orderNo: 'ORD-20250418-003', submittedAt: '2025-04-18 11:00', merchantName: '环球购物服务', agentName: '汇通金融服务', kycCount: 2, cardCount: 80, network: 'Visa', product: 'Visa Physical Tap', status: '已发货', progress: 100, trackingNo: 'SF-1234567890' },
  { orderNo: 'ORD-20250415-004', submittedAt: '2025-04-15 16:00', merchantName: '亿通数字服务', agentName: '星辰国际金融', kycCount: 2, cardCount: 15, network: 'Visa', product: 'Visa Physical Tap', status: '已驳回', progress: 0, rejectReason: 'KYC-4002 缺少地址证明，请补充后重新提交' },
];

// 实体卡审批流程节点
export const physicalApprovalFlow = [
  '① 商户提交申请',
  '② 中台审批通过',
  '③ 提交上游制卡 (制卡中)',
  '④ 人工导入库存',
  '⑤ 从库存派发卡片',
  '⑥ 填单发货',
];

// ===== 实体卡库存 =====
export interface OrigPhysicalCard {
  pan: string; // 4916 **** **** 9012
  internalId: string; // CRD003
  network: 'Visa' | 'Mastercard';
  bin: string; // 491600
  product: string; // 优享Visa商务实体卡
  tag?: string; // new-batch
  inboundDate: string; // 入库日期
  security: '在库安全' | '已分配' | '已激活' | '使用中';
}

export const physicalInventory: OrigPhysicalCard[] = [
  { pan: '4916 **** **** 9012', internalId: 'CRD003', network: 'Visa', bin: '491600', product: '优享Visa商务实体卡', tag: 'new-batch', inboundDate: '2025-03-01', security: '在库安全' },
];

export const physicalInventoryStats = {
  inStock: 1, // 在库待分配
  allocated: 1, // 已分配待激活
  inUse: 1, // 使用中
  threshold: 50, // 库存预警阈值
};

// ===== 商户钱包（水位预警 + 授信管理）=====
export interface OrigMerchantWallet {
  name: string;
  code: string; // MCH001
  walletBalance: number; // 商户余额
  cardBalance: number; // 卡片余额
  cardQuota: number; // 总额度
  creditRatio: string; // 2x
  totalRecharge: number; // 累计入金
  consumed: number; // 消费
  waterLevel: number; // 水位 %
  status: '正常' | '需追加入金' | '支付已受限';
  joinDate: string;
}

export const merchantWallets: OrigMerchantWallet[] = [
  { name: '环球购物服务', code: 'MCH001', walletBalance: 10000, cardBalance: 11500, cardQuota: 20000, creditRatio: '2x', totalRecharge: 10000, consumed: 8500, waterLevel: 85.0, status: '需追加入金', joinDate: '2024-01-20' },
  { name: '亿通数字服务', code: 'MCH002', walletBalance: 50000, cardBalance: 42000, cardQuota: 120000, creditRatio: '1.5x', totalRecharge: 80000, consumed: 78000, waterLevel: 97.5, status: '支付已受限', joinDate: '2024-02-14' },
  { name: '泰和智能科技', code: 'MCH003', walletBalance: 2000, cardBalance: 5500, cardQuota: 6000, creditRatio: '3x', totalRecharge: 2000, consumed: 500, waterLevel: 25.0, status: '正常', joinDate: '2025-04-08' },
  { name: '星辰跨境贸易', code: 'MCH004', walletBalance: 15000, cardBalance: 15500, cardQuota: 30000, creditRatio: '2x', totalRecharge: 15000, consumed: 14500, waterLevel: 96.7, status: '支付已受限', joinDate: '2024-06-12' },
  { name: '云端网络科技', code: 'MCH005', walletBalance: 100000, cardBalance: 45000, cardQuota: 240000, creditRatio: '1.2x', totalRecharge: 200000, consumed: 195000, waterLevel: 97.5, status: '支付已受限', joinDate: '2023-11-05' },
];

export const merchantWalletStats = {
  totalWallet: 177000, // 商户钱包总额
  totalCard: 416000, // 商户卡片总额
  avgCreditRatio: '1.9x', // 平均信贷配比
  warningCount: 4, // 预警商户数
};

// ===== VA 账户管理 =====
export interface OrigVaAccount {
  name: string; // 通联收款专用户-USD
  code: string; // VA-10001
  channelType: string; // Alipay Global
  currency: string; // USD
  balance: number;
  apiKey: string; // sk_live_...e8f9
  status: '启用中' | '已冻结';
}

export const vaAccounts: OrigVaAccount[] = [
  { name: '通联收款专用户-USD', code: 'VA-10001', channelType: 'Alipay Global', currency: 'USD', balance: 154200.50, apiKey: 'sk_live_...e8f9', status: '启用中' },
  { name: '本地网关-HKD', code: 'VA-10002', channelType: 'Local Gateway', currency: 'HKD', balance: 850000.00, apiKey: 'sk_live_...2a1c', status: '启用中' },
  { name: '测试通道备用', code: 'VA-10003', channelType: 'Test Channel', currency: 'USD', balance: 0, apiKey: 'sk_test_...9b22', status: '已冻结' },
];

// ===== 链上账户管理 =====
export interface OrigChainAccount {
  name: string; // 官方主钱包-TRC20
  code: string; // CA-10001
  network: 'TRC20' | 'ERC20';
  address: string; // TX9H...a8B1
  status: '启用中' | '已冻结';
}

export const chainAccounts: OrigChainAccount[] = [
  { name: '官方主钱包-TRC20', code: 'CA-10001', network: 'TRC20', address: 'TX9H...a8B1', status: '启用中' },
  { name: '官方主钱包-ERC20', code: 'CA-10002', network: 'ERC20', address: '0x1F...4b9c', status: '启用中' },
];

// ===== 风控规则 =====
export interface OrigRiskRule {
  category: string; // 速率风控 / AML 反洗钱
  tag: string; // 交易 / 合规 / 开卡 / 提现 / 代理商 / 安全
  desc: string; // 持卡人单日交易频率控制
  enabled: boolean;
  items: string[]; // 规则条目
}

export const riskRules: OrigRiskRule[] = [
  { category: '速率风控', tag: '交易', desc: '持卡人单日交易频率控制', enabled: true, items: ['单日消费次数 ≤ 20 次', '单小时消费次数 ≤ 5 次', '连续失败次数 ≤ 3 次'] },
  { category: 'AML 反洗钱', tag: '合规', desc: '资金来源与目的地检查', enabled: true, items: ['单笔交易 > $5,000 触发人工审核', '24小时累计 > $10,000 预警', 'OFAC制裁名单实时匹配'] },
  { category: '开卡风控', tag: '开卡', desc: '批量开卡行为拦截', enabled: true, items: ['单商户单日开卡 ≤ 50 张', '同身份证重复开卡检测', '新账户24小时内限额开卡'] },
  { category: '提现风控', tag: '提现', desc: '异常提现行为检测', enabled: true, items: ['单笔提现 ≤ $50,000', '单日提现 ≤ $100,000', '开卡后48小时内不可提现'] },
  { category: '保证金风控', tag: '代理商', desc: '代理商保证金余额监控', enabled: true, items: ['余额低于 $20,000 自动限制', '余额低于 $10,000 暂停开户', '余额为零自动冻结代理商'] },
  { category: '设备指纹', tag: '安全', desc: '异常设备访问检测', enabled: true, items: ['同IP多账户登录检测', 'Tor/VPN节点访问预警', '异常登录地理位置告警'] },
];

// ===== AML 合规检查 =====
export interface OrigAmlCase {
  code: string; // AML001
  type: string; // 制裁筛查 / 交易监控 / PEP核查 / 不利媒体 / STR申报
  level: '严重威胁' | '高风险' | '中等';
  match?: number; // 匹配度 %
  sourceTag?: string; // US-OFAC / HK-JFIU
  target: string; // 晨星跨境贸易 / 商户名
  desc: string;
  time: string;
  source: string; // SOURCE
  owner?: string; // OWNER
  status: '待处理' | '审查中' | '已上报' | '已清除';
}

export const amlCases: OrigAmlCase[] = [
  { code: 'AML001', type: '制裁筛查', level: '严重威胁', match: 97, sourceTag: 'US-OFAC', target: '晨星跨境贸易 KYC批次 KYCB002', desc: '商户KYC批次内1名持卡人国籍IR，资金流向地址命中OFAC SDN制裁名单（匹配度97%），已自动拦截并冻结相关开卡申请', time: '2025-04-14 14:55:00', source: 'OFAC SDN List', owner: '首席合规官 刘明', status: '已上报' },
  { code: 'AML002', type: '交易监控', level: '高风险', match: 85, target: '亿通数字服务 (MCH002)', desc: '商户旗下卡片30分钟内触发23笔连续小额订阅消费（$4.99-$15.99），符合"结构化分拆"特征，疑似用于测试被盗卡片有效性', time: '2025-04-14 22:15:00', source: '交易监控系统', owner: '合规专员 张明', status: '审查中' },
  { code: 'AML003', type: 'PEP核查', level: '中等', match: 72, target: '鼎盛金融集团 KYC批次', desc: '批次内1名持卡人姓名与公开PEP数据库（政治敏感人物）模糊匹配（匹配度72%），需人工核查身份证明文件', time: '2025-04-13 16:30:00', source: 'World-Check PEP Database', owner: '合规专员 李华', status: '已清除' },
  { code: 'AML004', type: '不利媒体', level: '中等', match: 68, target: '银河支付科技 (AGT005)', desc: '不利媒体扫描发现，代理商实控人公司名称在香港法院文件中出现（民事纠纷），建议核查背景材料并要求补充尽职调查文件', time: '2025-04-12 10:00:00', source: 'Adverse Media Monitor', status: '待处理' },
  { code: 'AML005', type: 'STR申报', level: '高风险', sourceTag: 'HK-JFIU', target: '环球购物服务 (MCH001)', desc: '商户单笔充值$50,000，达JFIU可疑交易申报阈值（HKD 200,000）。资金来源说明文件待核查，已暂停相关资金划拨', time: '2025-04-15 09:23:00', source: '资金监控规则引擎', status: '待处理' },
  { code: 'AML006', type: '制裁筛查', level: '严重威胁', match: 91, sourceTag: 'US-OFAC', target: '亿通数字服务 KYC批次 KYCB004', desc: '4份证件图片元数据异常，批次中疑似多身份证件欺诈，已退回商户。同时证件拍摄IP地址命中OFAC地理制裁区域（RU）', time: '2025-04-12 14:00:00', source: 'OFAC Geographic Sanctions', owner: '首席合规官 刘明', status: '已上报' },
];

export const amlStats = {
  pending: 4, // 待处理/已上报
  critical: 2, // 严重级别案例
  strPending: 1, // STR 待申报
  monthlyTotal: 6, // 本月案例总量
};

// ===== 3DS 中转管理 =====
export interface OrigThreeDsLog {
  id: string; // 3DS001
  merchant: string; // 环球购物服务
  pan: string; // 4111 **** **** 1234
  merchantOfSpend: string; // Amazon US
  amount: number;
  currency: string; // USD
  brand: string; // Allinks
  latency: number; // ms
  status: '验证成功' | '验证失败' | '验证中';
  time: string;
}

export const threeDsLogs: OrigThreeDsLog[] = [
  { id: '3DS001', merchant: '环球购物服务', pan: '4111 **** **** 1234', merchantOfSpend: 'Amazon US', amount: 299.99, currency: 'USD', brand: 'Allinks', latency: 1240, status: '验证成功', time: '2025-04-15 10:45:22' },
];

export const threeDsStats = {
  todayTotal: 1,
  success: 1,
  failed: 0,
  avgLatency: 1240, // ms
};

// ===== 数据报表 =====
export const reportTabs = ['综合概览', '卡片报表', '资金报表', '代理商分析'] as const;

export const reportStats = {
  monthlyRevenue: 234500,
  monthlyRevenueGrowth: 18.5,
  monthlyNewCards: 3120,
  monthlyNewCardsGrowth: 22.1,
  monthlySpend: 2100000,
  monthlySpendGrowth: 11.3,
  newCardholders: 892,
  newCardholdersGrowth: 9.7,
};

// 收益构成百分比
export const revenueComposition = [
  { label: '开卡费价差', value: 45, amount: 45200 },
  { label: '充值价差', value: 168, amount: 168300 },
  { label: 'Visa返佣', value: 21, amount: 21000 },
];

// 收益渠道明细
export const revenueChannels = [
  { label: '开卡费价差', sub: '系统结算', percent: 19.3, amount: 45200 },
  { label: '充值价差', sub: '层级分润', percent: 71.7, amount: 168300 },
  { label: 'Visa消费交易', sub: '季度返佣', percent: 9, amount: 21000 },
];

// ===== 邮件服务（3DS 邮件中转配置）=====
export const emailSmtpConfig = {
  senderEmail: 'noreply@allinks.io',
  senderName: 'Allinks Security',
  smtpServer: 'smtp.mailgun.org',
  smtpPort: '587',
  smtpUser: 'postmaster@allinks.io',
  smtpPass: '••••••••••••',
};

export const emailBrandRule = {
  upstreamKeywords: 'Allinpay, Tonglian, 通联',
  replaceBrand: 'Allinks',
  website: 'https://allinks.io',
  supportEmail: 'support@allinks.io',
};

// ===== 安全配置 =====
export interface OrigApiKey {
  name: string;
  updatedAt: string;
  expireAt: string;
  status: '有效' | '已过期';
  maskedKey: string; // sk-***...***
}

export const apiKeys: OrigApiKey[] = [
  { name: '通联支付 API Key', updatedAt: '2025-01-15', expireAt: '2026-01-15', status: '有效', maskedKey: 'sk-***...***' },
  { name: 'Visa 开发者密钥', updatedAt: '2025-02-01', expireAt: '2026-02-01', status: '有效', maskedKey: 'sk-***...***' },
  { name: 'HashKey 交易所密钥', updatedAt: '2025-03-10', expireAt: '2026-03-10', status: '有效', maskedKey: 'sk-***...***' },
  { name: 'Mailgun SMTP 密钥', updatedAt: '2025-01-08', expireAt: '2026-01-08', status: '有效', maskedKey: 'sk-***...***' },
];

export const securityAlertConfig = {
  largeWithdrawThreshold: 10000,
  failLockCount: 5,
  sessionTimeout: 30,
  ipWhitelistEnabled: '是',
};

export const ipWhitelist = ['203.0.113.10', '198.51.100.22', '192.0.2.88'];

// ===== 基础设置 =====
export const platformInfo = {
  name: 'Allinks',
  domain: 'allinks.io',
  region: '香港特别行政区',
  currency: 'USD / HKD',
  timezone: 'Asia/Hong_Kong (UTC+8)',
  language: '中文（繁体）/ English',
};

export const withdrawRule = {
  minAmount: 100,
  dailyLimit: 100000,
  delay: 'T+1',
  payoutWindow: '10:00 - 16:00',
};

export const notificationSettings = [
  { label: '大额交易邮件通知', enabled: true },
  { label: '风险告警短信推送', enabled: true },
  { label: '每日运营报告', enabled: true },
  { label: '系统异常Webhook', enabled: false },
];

// ============================================================
// 以下为 PRD 6 大中心补齐模块的 mock 数据
// ============================================================

// ===== 实时交易监控（卡片中心·实时交易流）=====
export interface OrigRealtimeTxn {
  id: string;
  cardPan: string; // 卡号掩码
  merchantName: string;
  amount: number;
  type: '消费' | '退款' | '充值' | '提现';
  channel: string;
  result: '成功' | '失败' | '待处理';
  riskTag?: '大额' | '高频' | '异地' | '高风险地区'; // 风控标记
  time: string; // YYYY-MM-DD HH:mm:ss
}

export const realtimeTransactions: OrigRealtimeTxn[] = [
  { id: 'TXN-RT-9001', cardPan: '4111****1234', merchantName: 'Amazon EU S.a.r.l', amount: 289.50, type: '消费', channel: 'Visa', result: '成功', riskTag: '异地', time: '2025-04-15 10:32:18' },
  { id: 'TXN-RT-9000', cardPan: '5241****8899', merchantName: 'Netflix International B.V', amount: 15.99, type: '消费', channel: 'Mastercard', result: '成功', time: '2025-04-15 10:31:45' },
  { id: 'TXN-RT-8999', cardPan: '4111****9911', merchantName: 'Stripe Inc', amount: 8500.00, type: '消费', channel: 'Visa', result: '待处理', riskTag: '大额', time: '2025-04-15 10:30:22' },
  { id: 'TXN-RT-8998', cardPan: '4532****7788', merchantName: '商户充值入账', amount: 5000.00, type: '充值', channel: '银行电汇', result: '成功', time: '2025-04-15 10:28:00' },
  { id: 'TXN-RT-8997', cardPan: '5241****0011', merchantName: 'Lucky Strike Casino', amount: 1200.00, type: '消费', channel: 'Mastercard', result: '失败', riskTag: '高风险地区', time: '2025-04-15 10:25:11' },
  { id: 'TXN-RT-8996', cardPan: '4111****2233', merchantName: 'Google Ireland Ltd', amount: 49.00, type: '消费', channel: 'Visa', result: '成功', riskTag: '异地', time: '2025-04-15 10:20:33' },
  { id: 'TXN-RT-8995', cardPan: '4111****1234', merchantName: 'Amazon EU S.a.r.l', amount: 78.20, type: '退款', channel: 'Visa', result: '成功', time: '2025-04-15 10:18:09' },
  { id: 'TXN-RT-8994', cardPan: '4532****5678', merchantName: 'AliExpress.com', amount: 156.80, type: '消费', channel: 'Visa', result: '成功', time: '2025-04-15 10:15:44' },
];

// ===== 争议处理（风控合规中心）=====
export interface OrigDispute {
  id: string;
  txnId: string; // 原交易号
  cardPan: string;
  amount: number;
  reason: '欺诈' | '服务争议' | '金额不符' | '未授权' | '商品未收到';
  status: '待处理' | '申诉中' | '已接受' | '已关闭';
  initiator: '持卡人' | '收单方';
  createdAt: string;
  slaHours: number;
  handler?: string;
}

export const disputes: OrigDispute[] = [
  { id: 'DSP-5001', txnId: 'TXN-8891', cardPan: '4111****1234', amount: 289.50, reason: '欺诈', status: '待处理', initiator: '持卡人', createdAt: '2025-04-14 16:00:00', slaHours: 20 },
  { id: 'DSP-5000', txnId: 'TXN-8856', cardPan: '5241****0011', amount: 1200.00, reason: '未授权', status: '申诉中', initiator: '收单方', createdAt: '2025-04-13 09:30:00', slaHours: 8, handler: '风控 李四' },
  { id: 'DSP-4999', txnId: 'TXN-8801', cardPan: '4111****9911', amount: 59.99, reason: '服务争议', status: '待处理', initiator: '持卡人', createdAt: '2025-04-12 14:20:00', slaHours: 40 },
  { id: 'DSP-4998', txnId: 'TXN-8775', cardPan: '4532****7788', amount: 199.00, reason: '商品未收到', status: '已接受', initiator: '持卡人', createdAt: '2025-04-11 10:00:00', slaHours: 0, handler: '风控 李四' },
  { id: 'DSP-4997', txnId: 'TXN-8702', cardPan: '5241****8899', amount: 15.99, reason: '金额不符', status: '已关闭', initiator: '持卡人', createdAt: '2025-04-10 08:00:00', slaHours: 0, handler: '风控 张明' },
  { id: 'DSP-4996', txnId: 'TXN-8655', cardPan: '4111****2233', amount: 78.20, reason: '欺诈', status: '申诉中', initiator: '收单方', createdAt: '2025-04-09 19:45:00', slaHours: -3, handler: '风控 李四' },
];

// ===== 合规管理（风控合规中心：清单/函件/案件）=====
export interface OrigComplianceItem {
  id: string;
  name: string; // 检查项名称
  category: '牌照' | '反洗钱' | '数据保护' | '财务' | '运营';
  status: '合规' | '待整改' | '即将到期' | '已过期';
  deadline: string;
  owner: string;
  lastChecked: string;
}

export const complianceItems: OrigComplianceItem[] = [
  { id: 'CMP-01', name: '香港 MSO 牌照', category: '牌照', status: '合规', deadline: '2026-12-31', owner: '法务 陈律', lastChecked: '2025-04-01' },
  { id: 'CMP-02', name: 'OFAC 制裁名单筛查', category: '反洗钱', status: '合规', deadline: '持续', owner: '合规 王审', lastChecked: '2025-04-14' },
  { id: 'CMP-03', name: 'GDPR 数据保护合规', category: '数据保护', status: '待整改', deadline: '2025-05-15', owner: '法务 陈律', lastChecked: '2025-03-20' },
  { id: 'CMP-04', name: 'PCI-DSS 支付安全认证', category: '运营', status: '即将到期', deadline: '2025-06-30', owner: '安全 赵工', lastChecked: '2025-04-10' },
  { id: 'CMP-05', name: '审计报告年度提交', category: '财务', status: '合规', deadline: '2025-12-31', owner: '财务 李总', lastChecked: '2025-04-05' },
  { id: 'CMP-06', name: '虚拟资产服务提供商注册', category: '牌照', status: '已过期', deadline: '2025-03-01', owner: '法务 陈律', lastChecked: '2025-02-15' },
];

export interface OrigRegulatoryLetter {
  id: string;
  from: string; // 来文机构
  subject: string;
  receivedAt: string;
  status: '待回复' | '已回复' | '归档';
  deadline?: string;
}

export const regulatoryLetters: OrigRegulatoryLetter[] = [
  { id: 'LTR-301', from: '香港海关', subject: '关于 2025 Q1 反洗钱抽查的通知', receivedAt: '2025-04-10', status: '待回复', deadline: '2025-04-25' },
  { id: 'LTR-300', from: 'Visa International', subject: '品牌保护合规问询（高风险 BIN）', receivedAt: '2025-04-08', status: '已回复', deadline: '2025-04-18' },
  { id: 'LTR-299', from: '香港金管局', subject: '储值支付工具季度报告要求', receivedAt: '2025-04-01', status: '已回复', deadline: '2025-04-15' },
  { id: 'LTR-298', from: 'Mastercard', subject: '交易拒付率异常通知', receivedAt: '2025-03-28', status: '归档' },
];

export interface OrigLegalCase {
  id: string;
  counterparty: string; // 对方当事人/机构
  cause: string; // 案由
  amount: number; // 涉案金额
  status: '立案' | '审理中' | '已结案' | '执行中';
  filedAt: string;
  handler: string;
}

export const legalCases: OrigLegalCase[] = [
  { id: 'CAS-201', counterparty: '某持卡人 张某', cause: '未授权交易索赔', amount: 8500, status: '审理中', filedAt: '2025-03-15', handler: '法务 陈律' },
  { id: 'CAS-200', counterparty: '某收单银行', cause: '清算差异纠纷', amount: 23000, status: '已结案', filedAt: '2025-01-20', handler: '法务 陈律' },
  { id: 'CAS-199', counterparty: '某代理商 汇通', cause: '佣金结算争议', amount: 12000, status: '立案', filedAt: '2025-04-12', handler: '法务 陈律' },
  { id: 'CAS-198', counterparty: '某商户 环球购物', cause: '服务合同违约', amount: 5000, status: '执行中', filedAt: '2025-02-10', handler: '法务 陈律' },
];

// ===== 资金调拨（财务中心）=====
export interface OrigTransfer {
  id: string;
  fromAccount: string; // 源账户
  toAccount: string; // 目标账户
  amount: number;
  currency: 'USD' | 'EUR' | 'GBP' | 'HKD';
  purpose: string; // 用途说明
  status: '待审批' | '已批准' | '已驳回' | '已完成';
  approver?: string;
  appliedAt: string;
  completedAt?: string;
}

export const transfers: OrigTransfer[] = [
  { id: 'TRF-7001', fromAccount: '汇丰运营主账户 · 123-456-789', toAccount: '渣打备付金账户 · 987-654-321', amount: 200000, currency: 'USD', purpose: '备付金池补足', status: '待审批', appliedAt: '2025-04-15 09:00:00' },
  { id: 'TRF-7000', fromAccount: '渣打备付金账户 · 987-654-321', toAccount: 'Visa 清算账户', amount: 85000, currency: 'USD', purpose: 'Visa 月度清算', status: '已批准', approver: '财务 李总', appliedAt: '2025-04-14 15:00:00' },
  { id: 'TRF-6999', fromAccount: '汇丰运营主账户 · 123-456-789', toAccount: 'USDT-TRC20 热钱包', amount: 50000, currency: 'USD', purpose: '链上入金兑付', status: '已完成', approver: '财务 李总', appliedAt: '2025-04-13 11:00:00', completedAt: '2025-04-13 11:30:00' },
  { id: 'TRF-6998', fromAccount: '花旗外汇账户', toAccount: '汇丰运营主账户 · 123-456-789', amount: 30000, currency: 'EUR', purpose: '欧元汇率套利归集', status: '已驳回', approver: '财务 李总', appliedAt: '2025-04-12 10:00:00' },
  { id: 'TRF-6997', fromAccount: '汇丰运营主账户 · 123-456-789', toAccount: 'Mastercard 清算账户', amount: 60000, currency: 'USD', purpose: 'Mastercard 清算', status: '已完成', approver: '财务 李总', appliedAt: '2025-04-11 14:00:00', completedAt: '2025-04-11 16:00:00' },
];

// ===== 多币种资金池（财务中心·操作台）=====
export interface OrigTreasuryPool {
  currency: 'USD' | 'EUR' | 'GBP' | 'HKD';
  totalBalance: number; // 总余额
  accounts: { name: string; balance: number; ratio: number }[]; // 各账户分布
  pendingInflow: number; // 待入金
  pendingOutflow: number; // 待出金
}

export const treasuryPools: OrigTreasuryPool[] = [
  {
    currency: 'USD', totalBalance: 4250000, pendingInflow: 350000, pendingOutflow: 120000,
    accounts: [
      { name: '汇丰运营主账户', balance: 2800000, ratio: 65.9 },
      { name: '渣打备付金账户', balance: 980000, ratio: 23.1 },
      { name: '花旗清算账户', balance: 470000, ratio: 11.0 },
    ],
  },
  {
    currency: 'EUR', totalBalance: 380000, pendingInflow: 20000, pendingOutflow: 35000,
    accounts: [
      { name: '花旗外汇账户', balance: 280000, ratio: 73.7 },
      { name: '汇丰欧元子账户', balance: 100000, ratio: 26.3 },
    ],
  },
  {
    currency: 'GBP', totalBalance: 120000, pendingInflow: 5000, pendingOutflow: 8000,
    accounts: [{ name: '汇丰英镑子账户', balance: 120000, ratio: 100 }],
  },
  {
    currency: 'HKD', totalBalance: 8800000, pendingInflow: 500000, pendingOutflow: 200000,
    accounts: [
      { name: '汇丰本地运营账户', balance: 6500000, ratio: 73.9 },
      { name: '中银港元结算账户', balance: 2300000, ratio: 26.1 },
    ],
  },
];

// ===== 对账管理（财务中心）=====
export interface OrigReconciliationBatch {
  id: string;
  period: string; // 对账周期
  counterparty: string; // 商户/通道
  expected: number; // 应收/应付
  actual: number; // 实收/实付
  diff: number; // 差异
  status: '已对平' | '有差异' | '待处理';
  createdAt: string;
  handler?: string;
}

export const reconciliationBatches: OrigReconciliationBatch[] = [
  { id: 'REC-4015', period: '2025-04-14', counterparty: '汇通金融服务', expected: 457000, actual: 457000, diff: 0, status: '已对平', createdAt: '2025-04-15 02:00:00', handler: '财务 王审' },
  { id: 'REC-4014', period: '2025-04-14', counterparty: 'Visa 清算通道', expected: 128000, actual: 127850, diff: -150, status: '有差异', createdAt: '2025-04-15 02:00:00', handler: '财务 王审' },
  { id: 'REC-4013', period: '2025-04-14', counterparty: '星辰国际金融', expected: 820000, actual: 821500, diff: 1500, status: '有差异', createdAt: '2025-04-15 02:00:00' },
  { id: 'REC-4012', period: '2025-04-13', counterparty: 'Mastercard 清算通道', expected: 96000, actual: 96000, diff: 0, status: '已对平', createdAt: '2025-04-14 02:00:00', handler: '财务 王审' },
  { id: 'REC-4011', period: '2025-04-13', counterparty: '鼎盛金融集团', expected: 480000, actual: 0, diff: -480000, status: '待处理', createdAt: '2025-04-14 02:00:00' },
];

// ===== 结算批次（财务中心·代理商价差结算）=====
export interface OrigSettlementBatch {
  id: string;
  agentName: string;
  agentId: string;
  spreadEarning: number; // 价差收益
  period: string; // 结算周期
  status: '待结算' | '已结算' | '已付款';
  itemCount: number; // 明细笔数
  settledAt?: string;
}

export const settlementBatches: OrigSettlementBatch[] = [
  { id: 'STL-3015', agentName: '鼎盛金融集团', agentId: 'AGT006', spreadEarning: 32000, period: '2025-04-01 ~ 2025-04-15', status: '待结算', itemCount: 156 },
  { id: 'STL-3014', agentName: '汇通金融服务', agentId: 'AGT002', spreadEarning: 12800, period: '2025-04-01 ~ 2025-04-15', status: '待结算', itemCount: 88 },
  { id: 'STL-3013', agentName: '星辰国际金融', agentId: 'AGT001', spreadEarning: 14353, period: '2025-03-16 ~ 2025-03-31', status: '已结算', itemCount: 72, settledAt: '2025-04-05 10:00:00' },
  { id: 'STL-3012', agentName: '东方通汇', agentId: 'AGT004', spreadEarning: 2100, period: '2025-03-16 ~ 2025-03-31', status: '已付款', itemCount: 21, settledAt: '2025-04-06 14:00:00' },
  { id: 'STL-3011', agentName: '汇通金融服务', agentId: 'AGT002', spreadEarning: 11500, period: '2025-03-16 ~ 2025-03-31', status: '已付款', itemCount: 65, settledAt: '2025-04-06 14:30:00' },
];

// ===== 托管管理（财务中心·Escrow）=====
export interface OrigEscrowSnapshot {
  id: string;
  snapshotTime: string;
  totalReserve: number; // 备付金总额
  escrowAmount: number; // 托管金额
  shortfall: number; // 缺口
  waterLevel: number; // 水位比例 %
  status: '健康' | '警戒' | '高危';
}

export const escrowSnapshots: OrigEscrowSnapshot[] = [
  { id: 'ESC-501', snapshotTime: '2025-04-15 00:00:00', totalReserve: 4250000, escrowAmount: 3180000, shortfall: 0, waterLevel: 74.8, status: '健康' },
  { id: 'ESC-500', snapshotTime: '2025-04-14 00:00:00', totalReserve: 3980000, escrowAmount: 3250000, shortfall: 0, waterLevel: 81.7, status: '警戒' },
  { id: 'ESC-499', snapshotTime: '2025-04-13 00:00:00', totalReserve: 3750000, escrowAmount: 3900000, shortfall: 150000, waterLevel: 104, status: '高危' },
  { id: 'ESC-498', snapshotTime: '2025-04-12 00:00:00', totalReserve: 3620000, escrowAmount: 3100000, shortfall: 0, waterLevel: 85.6, status: '警戒' },
  { id: 'ESC-497', snapshotTime: '2025-04-11 00:00:00', totalReserve: 3510000, escrowAmount: 2950000, shortfall: 0, waterLevel: 84.0, status: '警戒' },
];

// ===== 运营工单（运营中心）=====
export interface OrigOpsTicket {
  id: string;
  type: '投诉' | '咨询' | '故障' | '需求';
  source: '商户' | '代理商' | '持卡人' | '内部';
  priority: 'P0' | 'P1' | 'P2' | 'P3';
  title: string;
  status: '待分配' | '处理中' | '待用户确认' | '已关闭';
  assignee?: string;
  createdAt: string;
  slaHours: number;
}

export const opsTickets: OrigOpsTicket[] = [
  { id: 'TKT-9001', type: '故障', source: '商户', priority: 'P0', title: '批量开卡接口超时', status: '处理中', assignee: '技术 赵工', createdAt: '2025-04-15 08:30:00', slaHours: 2 },
  { id: 'TKT-9000', type: '投诉', source: '持卡人', priority: 'P1', title: '卡片被误冻结要求紧急解冻', status: '待分配', createdAt: '2025-04-15 09:15:00', slaHours: 6 },
  { id: 'TKT-8999', type: '咨询', source: '代理商', priority: 'P2', title: '4 月授权价调整规则咨询', status: '处理中', assignee: '运营 小钱', createdAt: '2025-04-14 14:00:00', slaHours: 18 },
  { id: 'TKT-8998', type: '需求', source: '内部', priority: 'P3', title: '报表增加 CSV 导出功能', status: '待用户确认', assignee: '产品 周理', createdAt: '2025-04-13 10:00:00', slaHours: 48 },
  { id: 'TKT-8997', type: '故障', source: '商户', priority: 'P1', title: '提现到账延迟', status: '已关闭', assignee: '财务 李总', createdAt: '2025-04-12 16:00:00', slaHours: 0 },
  { id: 'TKT-8996', type: '投诉', source: '代理商', priority: 'P2', title: '佣金结算金额异议', status: '处理中', assignee: '财务 王审', createdAt: '2025-04-12 11:00:00', slaHours: -4 },
];

